// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"278e32d3","845":"f7249eed"}[chunkId] + ".chunk.js";
};